import { LevelExercise } from "../components/LevelExercise";
import "./CoursePage.css";

function LevelExercisePage() {
  return (
    <div className="app">
      <div className="content">
        <LevelExercise />
      </div>
    </div>
  );
}

export default LevelExercisePage;